import { isMockingEnabled } from './config';

/**
 * Initialize MSW (Mock Service Worker) for development.
 * Only runs in development when REACT_APP_ENABLE_MOCKS=true.
 */
export async function initMSW(): Promise<void> {
  // eslint-disable-next-line no-console
  console.log('[MSW] REACT_APP_ENABLE_MOCKS =', process.env.REACT_APP_ENABLE_MOCKS);

  // Unregister any stale service worker if mocking is now disabled
  if (!isMockingEnabled()) {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (const registration of registrations) {
        if (registration.active?.scriptURL.includes('mockServiceWorker')) {
          await registration.unregister();
        }
      }
    }

    return;
  }

  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  try {
    const { worker } = await import('./browser');

    await worker.start({
      serviceWorker: {
        url: '/mockServiceWorker.js',
        options: { scope: '/' },
      },
      onUnhandledRequest(request) {
        // eslint-disable-next-line no-console
        console.log('[MSW] Unhandled request (bypassing):', request.method, request.url);
      },
      quiet: true,
    });

    // eslint-disable-next-line no-console
    console.log('[MSW] Mock Service Worker enabled');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[MSW] Failed to start:', error);
  }
}
